/**
 * Days a follow-up message is scheduled *after* a LinkedIn invite (connection request).
 *
 * A follow-up to an invite is only sent once the prospect accepts the connection
 * request, so an absolute calendar date is misleading. The relative offset
 * (e.g. "2 days later") matches how the backend schedules the follow-up — both
 * count from the invite/acceptance date rather than from today.
 *
 * Always at least 1: a follow-up is never sent at the same moment as the invite.
 *
 * @param followUpDays - the follow-up's `scheduledInDays` (days from now)
 * @param inviteDays - the invite's `scheduledInDays` (days from now)
 */
export const inviteRelativeDays = (
	followUpDays: number | null | undefined,
	inviteDays: number | null | undefined
): number => {
	const diff = (followUpDays ?? 0) - (inviteDays ?? 0);

	return Math.max(1, diff);
};
